import { css } from '@emotion/core';
import { Icon } from '@veeva/corgix/icon';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons/faSpinner';

import PropTypes from 'prop-types';
import NavigationTabs from '../../constants/NavigationTabs';
import HamburgerNavigation from '../HamburgerNavigation/HamburgerNavigation';
import mobileContainerHeightCSS from '../../constants/mobileContainerHeightCSS';

const propTypes = {
    children: PropTypes.node,
    childrenLoading: PropTypes.bool,
    headerContent: PropTypes.node,
    selectedTab: PropTypes.oneOf([
        NavigationTabs.HOME,
        NavigationTabs.SYSTEMS,
        NavigationTabs.STUDIES,
        NavigationTabs.GENERAL,
        NavigationTabs.EMAILS,
        NavigationTabs.CHANGE_PASSWORD,
        NavigationTabs.RECENT_ACTIVITY,
    ]),
};

const MyAccountLayoutMobile = ({ children, childrenLoading, headerContent, selectedTab }) => {
    return (
        <>
            <div
                css={css`
                    display: flex;
                    flex-direction: column;
                    width: 100vw;
                    overflow: scroll;
                    ${mobileContainerHeightCSS}
                    -webkit-tap-highlight-color: transparent; // Fix for Chrome mobile devices blue highlight on tap
                `}
            >
                <HamburgerNavigation headerContent={headerContent} selectedTab={selectedTab} />
                {childrenLoading ? (
                    <div
                        css={css`
                            align-items: center;
                            display: flex;
                            justify-content: center;
                            flex-grow: 1;
                        `}
                    >
                        <Icon spin type={faSpinner} color="#555555" size="xl" />
                    </div>
                ) : (
                    <div
                        css={css`
                            display: flex;
                            flex-direction: column;
                            padding: 2rem;
                            overflow: auto;
                        `}
                    >
                        {children}
                    </div>
                )}
            </div>
        </>
    );
};

MyAccountLayoutMobile.propTypes = propTypes;

export default MyAccountLayoutMobile;
